import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-addhiresourcepopup',
  templateUrl: './addhiresourcepopup.component.html',
  styleUrls: ['./addhiresourcepopup.component.css']
})
export class AddhiresourcepopupComponent implements OnInit, AfterViewInit {

  @ViewChildren('input')firstipcontrol;

  formname: string = "HiResource";

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
   isprivilage: boolean = false;
   showProgress: boolean = false;   


//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;

//Edit Get Values
hiresourceColl:any=[];
hiresourceBO:any={};
hiresourceid:number=0

hiresourceform=new FormGroup({
  hiresourceid:new FormControl(0),          
  hiresourcename:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});




  @Output() emitData = new EventEmitter();


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal,) {

    this.fnServiceChanges();
  }
    


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.hiresourceform.reset();
      this.fnInitializeFormGroup();

    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.hiresourceid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit() {
    //this.firstipcontrol.first.nativeElement.focus();
  }
  fnInitializeFormGroup() {
    this.hiresourceform.setValue({
      hiresourceid: 0,
      hiresourcename: '',
      inactive: false
    })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;        
    }
    
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.hiresourceform.valid) {
        //Check
        this.saveloading = true;

        var data = {
          'hiresourceid': this.hiresourceid,
          'hiresourcename': this.hiresourceform.get('hiresourcename').value,
          'inactive': this.hiresourceform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

console.log(data)
        this.appService.fnCheckHiResource(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
               
           
                  //Insert 
                  this.fnInsertHiResource(data);
     
              }
              else {
                if (_checkresult === "name") {
                  this.saveloading = false;

                  this.hiresourceform.controls['hiresourcename'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertHiResource(data) {

    this.appService.fnInsertHiResource(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {

           
            console.log( res.json())
            this.toastr.success('', "The new HiResource has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.paymode);
            var result = res.json().result;
            
            var hiresourceid = 0;
            if (result.length > 0) {
              hiresourceid = result[0].hiresourceid
            }
            this.emitData.emit(hiresourceid);
            this.activeModal.close(true);
  

          }  
          else {
            this.loginService.fnAPIError(res.json())
          }
        }
        (err) => {
          this.saveloading = false;        
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }


}

